define('coorganizer-search',['require','knockout','api-access'],function (require) {
    var ko = require('knockout');
    var userApi = require('api-access').user;

    /**
     * On the fly search for co-organizers
     * example: <input class="form-control" type="text" data-bind="coorganizerSearch: coorgQuery, value: coorgQuery,
     * valueUpdate: 'keyup', organizerKey: organizerKey, coorganizers: coorganizers, coorgResults: coorgResults">
     *
     * @param coorgQuery, organizerKey, coorganizers, coorgResults
     * @return array of co-organizers
     */
    ko.bindingHandlers.coorganizerSearch = {
        update: function (element, valueAccessor, allBindingsAccessor) {
            var query = valueAccessor();
            var organizerKey = allBindingsAccessor().organizerKey();
            var coorganizers = allBindingsAccessor().coorganizers();
            var results = allBindingsAccessor().coorgResults;
            var key = ['and(key != ' + organizerKey + 'L)'];

            ko.utils.arrayForEach(coorganizers, function (coorg) {
                key.push('and(key != ' + coorg.key + 'L)');
            });

            if (ko.unwrap(query)) {
                if (query().length >= 2) {
                    userApi.getFilteredCoorganizers(key.join(''), query())
                        .then(function (data) {
                            results(data.results);
                        });
                } else {
                    results.removeAll();
                }
            }
        }
    };
});

